// extracted by mini-css-extract-plugin
module.exports = {"created-button":"created-button-0ffcd85c904cdd37655599015a99b507"};